<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { useLocation } from 'svelte-navigator';
  // import Logo from '../assets/icons/logo.svg.svelte';
  import Logo from '../assets/icons/logo.png';

  export let isAppActive = true;
  // export let isStartingInFuture = false;

  const location = useLocation();

  $: pageTitle = (() => {
    if (!isAppActive) {
      return $_('Welcome');
    }

    const path = $location?.pathname || '';
    if (path.includes('/step/1')) {
      return $_('Registration');
    }
    if (path.includes('/step/2')) {
      return $_('Purchase Information');
    }
    if (path.includes('/step/3')) {
      return $_('Personal Information');
    }
    if (path.includes('/step/4')) {
      return $_('Questions');
    }
    if (path.includes('/step/5')) {
      return $_('Submit Application');
    }
    return $_('Welcome');
  })();
</script>

<div class="bg-black">
  <div class="mx-auto flex items-center px-4 py-4 sm:px-6 sm:py-5">
    <div class="flex flex-1 items-center justify-start">
      <span class="font-CorpoS text-2xl leading-tight text-white sm:text-3xl capitalize">
        {#key pageTitle}
          <span>{pageTitle}</span>
        {/key}
      </span>
    </div>

    <div class="flex items-center justify-center">
      <!-- <Logo class="h-10 w-10 sm:h-12 sm:w-12" /> -->
      <img
        src={Logo}
        alt="Mercedes-Benz Logo"
        class="h-10 w-10 sm:h-12 sm:w-12"
      />
    </div>

    <div class="flex flex-1 items-center justify-end">
      <span class="font-CorpoS text-2xl leading-tight text-white sm:text-3xl text-right">
        Mercedes-Benz Online Store - Cashback-Aktion
      </span>
    </div>
  </div>
</div>
